import React, { Suspense } from "react";
import Category from "../components/Category/Category";
import Products from "../components/Products";
import MainSlider from "../components/Slider/Slider";
import ProductContent from "../components/ProductContent/ProductContent";
import Parallax from "../components/Parallax/Parallax";
import Bloglist from "../components/Blogs/Bloglist";

const Home = () => {
  const renderLoader = () => <p>Loading</p>;

  return (
    <div>
      <MainSlider />
      <Category />
      <Suspense fallback={renderLoader()}>
        <ProductContent />
      </Suspense>
      <Parallax />
      <Bloglist />
    </div>
  );
};

export default Home;
